import Icon from '@components/common/Icon';

const skills = [
  {
    category: 'Performance',
    items: ['Violin', 'Recital Performance', 'Ensemble Playing', 'Solo Performance'],
  },
  {
    category: 'Technical',
    items: ['Bow Control', 'Finger Dexterity', 'Vibrato', 'Double Stops'],
  },
  {
    category: 'Knowledge',
    items: ['Music Theory (Grade 5)', 'Classical Repertoire', 'Sight Reading', 'Ensemble Dynamics'],
  },
  {
    category: 'Styles',
    items: ['Classical', 'Baroque', 'Romantic', 'Contemporary'],
  },
];

const SkillsSection = () => {
  return (
    <section
      className="py-20 px-4 sm:px-6 lg:px-8"
      style={{
        backgroundColor: 'var(--color-theme-2)',
      }}
    >
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2
            className="text-4xl sm:text-5xl font-heading font-bold tracking-tight"
            style={{ color: 'var(--color-heading)' }}
          >
            Musical Skills & Competencies
          </h2>
          <p
            className="text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            Skills I have developed through years of dedicated practice and performance experience
          </p>
        </div>

        {/* Skills - Horizontal Scroll on Mobile */}
        <div className="lg:grid lg:grid-cols-4 md:grid md:grid-cols-2 flex lg:flex-none md:flex-none overflow-x-auto gap-6 lg:gap-8 snap-x snap-mandatory scrollbar-hide pb-4 -mx-4 px-4 sm:mx-0 sm:px-0">
          {skills.map((skill, idx) => (
            <div
              key={idx}
              className="rounded-2xl overflow-hidden shadow-card transition-all duration-300 hover:shadow-card-hover flex-shrink-0 w-[85vw] sm:w-[60vw] md:w-auto snap-center"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)',
                borderWidth: '1px',
                borderStyle: 'solid',
              }}
            >
              {/* Header */}
              <div
                className="p-6 space-y-4"
                style={{
                  background: `linear-gradient(135deg, var(--color-accent-2), var(--color-accent-1))`,
                }}
              >
                <h3
                  className="text-2xl font-bold"
                  style={{ color: 'var(--color-accent-7)' }}
                >
                  {skill.category}
                </h3>
              </div>

              {/* Skills List */}
              <div className="p-6 space-y-3">
                {skill.items.map((item, itemIdx) => (
                  <div key={itemIdx} className="flex items-start gap-3">
                    <svg
                      className="w-5 h-5 mt-0.5 flex-shrink-0"
                      style={{ color: 'var(--color-accent-6)' }}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span
                      className="text-base"
                      style={{ color: 'var(--color-card-text)' }}
                    >
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
